import React from 'react';
import './CollaborationBanner.css';

const CollaborationBanner = () => {
  return (
    <section className="collaboration-banner">
      <div className="container">
        <div className="collaboration-content">
          <div className="collaboration-text">
            <span className="collaboration-label">IN COLLABORATION WITH</span>
          </div>
          <div className="collaboration-logos">
            <div className="logo-item">
              <img 
                src="/images/aviator1903-logo.png" 
                alt="Aviator1903" 
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
            <div className="logo-divider">×</div>
            <div className="logo-item">
              <img 
                src="/images/worldwidewings-logo.png" 
                alt="Worldwide Wings" 
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollaborationBanner;
